import { defineStore } from "pinia";
import { UserApiClient } from '@/client/requests';
import { SessionOut } from '@/client/types';


export const sessionStore = defineStore('session', {
  state: () => ({
    session: null as SessionOut | null,
  }),
  actions: {
    async fetchSession() : Promise<void> {
      const apiClient = new UserApiClient
      this.session = await apiClient.getUserSession();
    },
    setSession(session: SessionOut) : void {
      this.session = session;
      sessionStorage.setItem('session', JSON.stringify(session));
    },
    clearSession() : void {
      this.session = null;
      sessionStorage.removeItem('session');
    },
    loadSession() : void {
      this.session = sessionStorage.getItem('session') ? JSON.parse(sessionStorage.getItem('session') as string) : null;
    }  
  },
  getters: {
    isAuthenticated: (state: any) => !!state.session?.token,
    userEmail: (state: any) => state.session?.user.email,
    userPermissions: (state: any) => state.session?.user.permissions,
    token: (state: any) => state.session?.token,
  },
});


